import $ from "jquery";

// --------- Change this to appropriate URL when deploying -----------
// const apiUrl = "https://testmetrocardapi.ecan.govt.nz/Account/customerBalance/";
// const apiUrl = "https://metrocardapi.ecan.govt.nz/Account/customerBalance/";
const apiUrl = "/api/balance";
const loginUrl = "https://metrocard.metroinfo.co.nz/#/login";
const orderCardUrl = "https://metrocard.metroinfo.co.nz/#/orderCard";
//-------------------------------------------------------------------

// The MetrocardBalance.ss include can appear more than once on a page
// (e.g. intro widget + sidebar widget), so every lookup below is scoped
// to a single $widget instance instead of relying on page-wide ids.
const initCardBalanceWidget = ($widget, recaptchaWidgetId) => {
  const $metrocardno = $widget.find(".metro-card-no");
  const $cardBalance = $widget.find(".card-balance");
  const $pendingAmount = $widget.find(".pending-amount");
  const $busyDiv = $("#cardBalanceBusy");
  const $spinner = $("#cardBalanceSpinner");
  const $inputserrorMessage = $widget.find(".inputsErrorMessage");
  const $balanceerrorMessage = $widget.find(".balanceerrorMessage");
  const $metrocardnoforbalance = $widget.find(".metrocardnoforbalance");
  const $inputs = $widget.find(".mcb-inputs");
  const $balance = $widget.find(".mcb-balance");
  const $balanceok = $widget.find(".balanceok");
  const $balanceerror = $widget.find(".balanceerror");
  const $checkanothercard = $widget.find(".checkanothercard");
  const $showbalance = $widget.find(".showbalance");
  const $login = $widget.find(".js-login");
  const $ordercard = $widget.find(".js-ordercard");

  const showSpinner = () => {
    $spinner.addClass("spinner");
    $busyDiv.show();
  };

  const hideSpinner = () => {
    $spinner.removeClass("spinner");
    $busyDiv.hide();
  };

  const hideAllElements = () => {
    $balance.hide();
    hideSpinner();
  };

  const fadeOutErrorMessage = () => {
    $inputserrorMessage.css("filter", "alpha(opacity=40)");
    $inputserrorMessage.fadeOut(500);
    $inputserrorMessage.html("");
  };

  const displayMetrocardErrorMessage = errorMsg => {
    $inputserrorMessage.html(errorMsg);
    $inputserrorMessage.css("filter", "alpha(opacity=40)");
    $inputserrorMessage.fadeIn(500);
    setTimeout(fadeOutErrorMessage, 4000);
  };

  const getBalance = (cardNumber, recaptchaToken) => {
    showSpinner();
    $balanceok.hide();
    $balanceerror.hide();

    const data = {
      cardNumber,
      recaptchaToken
    };

    $.post(apiUrl, data)
      .done(response => {
        if (response) {
          $metrocardno.html(cardNumber);
          $cardBalance.html(`$${response.balance.toFixed(2)}`);
          $pendingAmount.html(
            `Pending amount: $${response.pendingTopupAmount.toFixed(2)}`
          );
          $balanceok.show();
        } else {
          $balanceerrorMessage.html(response.errorMessage);
        }
      })
      .fail(error => {
        $balanceok.hide();
        $balanceerror.show();
        switch (error.status) {
          case 200:
            $balanceerrorMessage.html(
              "Sorry, we couldn't find that card. Please check the number and try again."
            );
            break;
          default:
            $balanceerrorMessage.html(
              "Oops, something isn't quite working. Please check your internet connection and try again in a few moments."
            );
        }
      })
      .always(() => {
        $balance.show();
        $inputs.hide();
        $checkanothercard.show();
        hideSpinner();
      });
  };

  // Show our input fields
  $inputs.show();
  // Hide all elements
  hideAllElements();

  // Bind event listeners
  $showbalance.click(() => {
    /* eslint-disable-next-line */
    const recaptchaToken = grecaptcha.getResponse(recaptchaWidgetId);
    const cardNumber = $metrocardnoforbalance.val();

    if (Number.isNaN(Number(cardNumber)) || !cardNumber || cardNumber < 0) {
      displayMetrocardErrorMessage("Invalid Metrocard number");
      return false;
    }

    if (!recaptchaToken) {
      displayMetrocardErrorMessage(
        'Please tick the "Recaptcha" box to continue'
      );
      return false;
    }

    $inputserrorMessage.html("");
    getBalance(cardNumber, recaptchaToken);
    return false;
  });

  $login.click(() => {
    window.open(loginUrl, "_blank");
    return false;
  });

  $ordercard.click(() => {
    window.open(orderCardUrl, "_blank");
    return false;
  });

  $checkanothercard.click(() => {
    $inputs.show();
    $balance.hide();
    grecaptcha.reset(recaptchaWidgetId); // eslint-disable-line
    $inputserrorMessage.html("");
    $balanceerrorMessage.html("");
    return false;
  });
};

const cardBalanceWidget = () => {
  $(".mcb-widget").each((recaptchaWidgetId, el) => {
    initCardBalanceWidget($(el), recaptchaWidgetId);
  });
};

export default cardBalanceWidget;
